<template lang="pug">
.v-feature-cards.feature-cards(v-if="data" :class="[view ? 'feature-cards--' + view : null ]" :id="data?.id")
	.feature-cards__tabs(v-if="data.tabs")
		v-tags(:tags="data" @emitItems="updateItems")
	.feature-cards__items(v-if="data.items && data.items.length")
		a.feature-cards__item(v-for="item in data.items" :style="{backgroundImage: `url('${item.backgroundImage}')`,backgroundColor: item.backgroundColor}" :href="item.link")
			.feature-cards__item-title(v-if="item.title" :style="{color: item.title.color}") {{item.title.text}}
			img.feature-cards__item-banner(v-if="item.image" :src="item.image.src" :alt="item.image.alt")
			.feature-cards__item-text(v-if="item.text" :style="{color: item.text.color}") {{item.text.text}}
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";

export default {

	mixins: [
		sourceMixin
	],

	props: {
		view: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			data: null,
			active: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		updateItems(items) {
			this.data.items = items;
		}
	}
}

</script>